import React, { useState } from "react";
import useAdminData from "../hooks/useAdminData";

const AdminDashboard: React.FC = () => {
  const [password, setPassword] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);

  const RECORDS_PER_PAGE = 50;

  const { data, authenticated, login } = useAdminData();

  const handlePwChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setPassword(e.target.value);
  };

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const handleLogin = () => {
    login(password);
    setPassword("");
  };

  if (!authenticated) {
    return (
      <div>
        <h1>Admin Login</h1>
        <input
          type="password"
          placeholder="čau Heslo heslíčko"
          value={password}
          onChange={handlePwChange}
          onKeyDown={handleEnter}
          autoFocus
        />
        <button onClick={handleLogin}>Login</button>
      </div>
    );
  }

  const sortedData = [...data].sort((a, b) => {
    return (
      new Date(b.analysisDate).getTime() - new Date(a.analysisDate).getTime()
    );
  });

  const totalRecords = sortedData.length;
  const totalPages = Math.ceil(totalRecords / RECORDS_PER_PAGE);

  const currentPageData = sortedData.slice(
    (currentPage - 1) * RECORDS_PER_PAGE,
    currentPage * RECORDS_PER_PAGE,
  );

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const capitalizeFirstLetter = (str: string): string => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  interface Analysis {
    _id: string;
    feedType: string;
    analysisDate: string;
    shopLink: string;
    totalMissingProducts: number;
  }

  interface AnalysisRowProps {
    analysis: Analysis;
  }

  const AnalysisRow: React.FC<AnalysisRowProps> = ({ analysis }) => {
    const { feedType, analysisDate, shopLink, totalMissingProducts } = analysis;
    return (
      <tr key={analysis._id}>
        <td>{capitalizeFirstLetter(feedType)}</td>
        <td>{new Date(analysisDate).toLocaleString("cs-CZ")}</td>
        <td>
          <strong>{shopLink}</strong>
        </td>
        <td>{totalMissingProducts}</td>
      </tr>
    );
  };

  return (
    <div>
      <h1>Historie používání</h1>
      {totalRecords > 0 ? (
        <>
          <table>
            <thead>
              <tr>
                <th>Typ feedu</th>
                <th>Datum kontroly</th>
                <th>URL obchodu</th>
                <th>Počet chybějících produktů</th>
              </tr>
            </thead>
            <tbody>
              {currentPageData.map((analysis) => (
                <AnalysisRow key={analysis._id} analysis={analysis} />
              ))}
            </tbody>
          </table>
          {totalPages !== 1 && (
            <div className="pagination">
              <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                ← Předchozí
              </button>
              <span>
                Stránka {currentPage} z {totalPages}
              </span>
              <button
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
              >
                Následující →
              </button>
            </div>
          )}
        </>
      ) : (
        <p>Načítání dat...</p>
      )}
    </div>
  );
};

export default AdminDashboard;
